import React from 'react';

export default function ToggleSwitch({ enabled, setEnabled }) {
    return (
        <label className="toggle-switch">
            <input
                type="checkbox"
                checked={enabled}
                onChange={() => setEnabled(!enabled)}
            />
            <span className="toggle-slider"></span>
        </label>
    );
}